<template>
  <v-container>
    <h2 class="gradation mt-2">見つける</h2>

    <v-form v-if="searchContents.length == 0 && !isLoading" class="search-form">
      <v-text-field v-model="searchText" label="キーワード（スペース区切り）" @keydown.enter="search" color="primary" variant="outlined" dense></v-text-field>
      <h3 class="mt-5">ステータス</h3>
      <v-btn-toggle v-model="searchRecruiting" color="secondary-container" variant="flat" class="border rounded-pill w-100" mandatory>
        <v-btn text value="2" class="v-col-6">募集中のみ</v-btn>
        <v-btn text value="" class="v-col-6">すべて</v-btn>
      </v-btn-toggle>
      <h3 class="mt-5">並び順</h3>
      <v-btn-toggle v-model="searchOrder" color="secondary-container" variant="flat" class="border rounded-pill w-100" mandatory>
        <template v-for="(item, index) in orderOptions" :key="index">
          <v-btn text :value="index" class="v-col-4">{{ item }}</v-btn>
        </template>
      </v-btn-toggle>
      <div class="search__button_area">
        <v-btn color="primary" @click="search" block class="rounded-pill" size="large">検索</v-btn>
      </div>
    </v-form>
    <div v-if="searchContents.length != 0">
      <v-btn @click="viewSearchForm" block color="primary-container" variant="flat" class="rounded-pill">再度検索する</v-btn>
    </div>

    <div class="mt-7">
      <NowLoading
        :is-loading="isLoading"
        :loading-height="loadingHeight"
        :loading-padding="loadingPadding"
      />
      <div v-if="!isLoading && searchContents.length != 0">
        <div class="mr-3 mb-2"><span class="search__numbers">{{ searchContents.length }}</span>件</div>
        <v-row no-gutters>
          <v-chip class="mr-3 mb-2" color="primary" v-if="searchText">{{ searchText }}</v-chip>
          <v-chip class="mr-3 mb-2" color="primary">{{ searchRecruiting == 2 ? '募集中のみ' : 'すべて' }}</v-chip>
          <v-chip class="mr-3 mb-2" color="primary">{{ orderOptions[searchOrder] }}</v-chip>
        </v-row>
      </div>
      <div v-if="searchType == 'fund'">
        <template v-for="content in searchContents" :key="content">
          <fund-tile
            class="article my-3"
            :fund-id="content.fund_id"
            :fund-name="content.fund_name"
            :explanation-short="content.explanation_short"
            :partner-name="content.partner_name"
            :thumbnail-uri="'/data/fund/' + content.fund_id + '/top.jpg'"
            :is-watch="watchListMap[content.fund_id]"
            :price="content.one_price"
            :amount="content.summary_suryo"
            :total-amount="content.total_suryo"
            :supporter="content.supporters"
          />
        </template>
      </div>
      <div v-if="searchType == 'ec'">
        <template v-for="content in searchContents" :key="content">
          <EcTile
            class="article my-3"
            :ec-item-id="content.ec_item_id"
            :ec-item-name="content.item_name"
            :ec-item-price="content.price"
            :explanation="content.explanation_short"
            :partner-name="content.partner_name"
            :thumbnail-uri="'/data/ec/' + content.ec_item_id + '/main.jpg'" 
            :is-watch="watchListMap[content.ec_item_id]"
            />
        </template>
      </div>
    </div>

</v-container>
</template>

<script>
import NowLoading from '../components/NowLoading.vue';
import FundTile from '../components/FundTile.vue';
import EcTile from '../components/EcTile.vue';
import axios from 'axios';

export default {
  name: 'SearchPage',
  components: {
    NowLoading,
    FundTile,
    EcTile
  },
  data: () => ({
    isLoading: false,
    loadingHeight: '200',
    loadingPadding: '50',
    searchContents: [],
    watchListMap: [],
    searchText: '',
    searchType: 'fund',
    searchRecruiting: '2',
    searchOrder: '1',
    orderOptions: {
      1: '新着順',
      2: '終了日順',
      3: '人気順'
    }
  }),
  mounted() {
    // ルーティング時に検索パラメータがあれば検索を実行
    const params = new URLSearchParams(window.location.search);
    if(params.get('keyword')){
      this.searchText = params.get('keyword');
      this.searchType = params.get('type');
      this.search();
    }
   },
  created() { },
  methods: {
    search() {
      this.isLoading = true;
      try{
        this.searchContents = [];
        const query = {
          keyword: this.searchText,
          recruiting: (this.searchRecruiting) ? this.searchRecruiting : '',
          type: this.searchType,
          order: this.searchOrder
        };
        console.log(query);
        axios.get('/api/search', {
          params: query
        }).then((res) => {
          console.log(res.data);
          if(res.data.items.length == 0){
            alert('検索結果は0件です。');
          }else{
            this.searchContents = res.data.items;
            this.watchListMap = res.data.watchListMap;
          }
          this.isLoading = false;
        }).catch((error) => {
          console.error(error);
          this.isLoading = false;
          alert('検索に失敗しました。再度お試しください。');
        })
      }catch(e){
        console.error(e);
        this.isLoading = false;
        alert('検索に失敗しました。再度お試しください。');
      }
    },
    viewSearchForm() {
      this.searchContents = [];
    }
  }
}
</script>

<style scoped>
h3 {
  color: #0168b7;
}
.search-form {
  margin-bottom:80px;
}
.search__button_area{
  position: fixed; 
  padding: 10px; 
  bottom: 80px; 
  left: 0; 
  width: 100%;
  z-index: 2;
}
.search__numbers {
  font-size: 20px;
  color: #0168b7;
}

.v-btn-group .v-btn:not(.v-btn--active) {
  background: #fff;
}
</style>